import logoImg from './fff-logo.png';
import * as styles from './LoadingLogo.module.css';

const LoadingLogo = () => (
  <div className={styles.container}>
    <img className={styles.loadingImage} src={logoImg} alt="Loading..." />
  </div>
);

export default LoadingLogo;
